// src/features/home/Routes.jsx
import { Route } from 'react-router-dom';
import HomePage from './pages/HomePage';

export const HomeRoutes = () => (
  <Route path="home" element={<HomePage />} />
);
